import { render, staticRenderFns } from "./widget-component-dossier-atgs.vue?vue&type=template&id=35099c30&scoped=true"
import script from "./widget-component-dossier-atgs.vue?vue&type=script&lang=ts"
export * from "./widget-component-dossier-atgs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35099c30",
  null
  
)

export default component.exports